
import store from '../store';
import Constants from '../config/constants';
import {serviceCreateAdmin, serviceGetAdmin, serviceUpdateAdmin,serviceDeleteAdmin} from "../services/AdminUsers.service";

export const FETCH_INIT = 'FETCH_INIT_ADMIN';
export const FETCHED = 'FETCHED_ADMIN';
export const FETCHED_FAIL = 'FETCHED_FAIL_ADMIN';
export const FETCHED_FILTER = 'FETCHED_FILTER_ADMIN';
export const FETCH_NEXT = 'FETCH_NEXT_ADMIN';
export const FILTER = 'FILTER_ADMIN';
export const RESET_FILTER = 'RESET_FILTER_ADMIN';
export const SET_SORTING = 'SET_SORTING_ADMIN';
export const SET_FILTER = 'SET_FILTER_ADMIN';
export const SET_PAGE = 'SET_PAGE_ADMIN';
export const CHANGE_PAGE = 'CHANGE_PAGE_ADMIN';
export const CHANGE_STATUS= 'CHANGE_STATE_ADMIN';
export const SET_SERVER_PAGE = 'SET_SERVER_PAGE_ADMIN';
export const CREATE_DATA = 'CREATE_ADMIN';
export const UPDATE_DATA = 'UPDATE_ADMIN';
export const DELETE_ITEM = 'DELETE_ADMIN';
export const DRAG_ITEM = 'DRAG_ADMIN';

export function actionFetchAdmin(index = 1, sorting = {}, filter = {}, shouldReset=false) {
    const request = serviceGetAdmin({ index, row: sorting.row, order: sorting.order, ...filter });
    return (dispatch) => {
        if (shouldReset) {
            dispatch({
                type: CHANGE_PAGE,
                payload: 1,
            });
        }
        dispatch({type: FETCH_INIT, payload: null});
        request.then((data) => {
            dispatch({type: SET_FILTER, payload: filter});
            dispatch({type: SET_SORTING, payload: sorting});
            if (!data.error) {
                dispatch({type: FETCHED, payload: { data: data.data, page: index }});
                dispatch({ type: SET_SERVER_PAGE, payload: index });
                if (index == 1) {
                    dispatch({type: CHANGE_PAGE, payload: index - 1});
                }
            } else {
                dispatch({type: FETCHED_FAIL, payload: null});
            }
        });
    };
}



export function actionCreateAdmin(data) {
    const request = serviceCreateAdmin(data);
    return (dispatch) => {
        request.then((data) => {
            if (!data.error) {
                dispatch({type: CREATE_DATA, payload: data.data})
            }
        })
    }
}

export function actionUpdateAdmin(data) {
    const request = serviceUpdateAdmin(data);
    return (dispatch) => {
        request.then((data) => {
            if (!data.error) {
                dispatch({type: UPDATE_DATA, payload: data.data})
            }
        })
    }
}

export function actionDeleteAdmin(id) {
    const request = serviceDeleteAdmin({ id: id});
    return (dispatch) => {
        dispatch({type: DELETE_ITEM, payload: id})
    }
}


export function actionChangePageAdminRequests(page) {
    return (dispatch) => {
        dispatch({type: CHANGE_PAGE, payload: page})
    }
}

export function actionFilterAdmin(value) {
    const request = null;////serviceFetchProviderRequests(value);
    return (dispatch) => {
        dispatch({type: FETCH_INIT, payload: null});
        request.then((data) => {
            dispatch({type: FILTER, payload: data});
            dispatch({type: FETCHED, payload: null});//dispatch function
        });
    };
}


export function actionChangeStatusAdmin(id, status) {
    // const request = serviceFetchProviderRequests(value);
    return (dispatch) => {
        dispatch({type: CHANGE_STATUS, payload: {id, status}});
    };
}

export function actionResetFilterAdmin() {
    return {
        type: RESET_FILTER,
        payload: null,
    };
}

export function actionDragAdmin(dragId, dragOverId) {
    return {
        type: DRAG_ITEM,
        payload: {dragId, dragOverId}
    }
}

export function actionSetPageAdmin(page) {
    const stateData = store.getState().admin;
    const currentPage = stateData.currentPage;
    const totalLength = stateData.all.length;
    const sortingData = stateData.sorting_data;
    const query = stateData.query;
    const queryData = stateData.query_data;
    const serverPage = stateData.serverPage;

    if (totalLength <= ((page + 1) * Constants.DEFAULT_PAGE_VALUE)) {
        store.dispatch(actionFetchAdmin(serverPage + 1, sortingData, {query, query_data: queryData}));
    }


    return {
        type: CHANGE_PAGE,
        payload: page,
    };

}
